import {
  takeLatest,
  call,
  put,
} from "redux-saga/effects"
import { message } from "antd"
import cookie from "react-cookies"
import { isSuccess } from "services/Utils"
import {
  getAllReferralsAPI,
  createReferralAPI,
  getReferralDetailsAPI,
  updateReferralCoverAPI,
  updateReferralStatusAPI,
} from "./api"
import {
  getAllReferralsAction,
  createReferralAction,
  getReferralDetailsAction,
  saveReferralCoverAction,
  updateReferralStatusAction,
  toggleReferralDrawerAction,
} from "./actions"

function* handleFetchReferrals(action) {
  try {
    const payload = action.data
    const res = yield call(getAllReferralsAPI, payload)
    if (isSuccess(res)) {
      const { response } = res.data
      yield put(getAllReferralsAction.success(response))
    }
  } catch (e) {
    yield put(getAllReferralsAction.failure(e))
  }
}

function* handleCreateReferral(action) {
  try {
    const { payload, callback, skipAutoOpen } = action.data
    const res = yield call(createReferralAPI, payload)
    if (isSuccess(res)) {
      const { response } = res.data
      yield put(createReferralAction.success(response))

      if (response && response.referral_id && !skipAutoOpen) {
        yield put(getReferralDetailsAction.request({
          referralId: response.referral_id,
          agentId: payload && payload.agent_id,
        }))
        yield put(toggleReferralDrawerAction.call({
          bool: true,
          data: {
            referral_id: response.referral_id,
            primaryAgentId: payload && payload.agent_id,
            agent_id: payload && payload.agent_id,
          },
        }))
      }

      yield put(getAllReferralsAction.request({
        skip: 0,
        limit: 25,
        sort_by: "created_at",
        sort_order: "desc",
      }))

      if (callback) callback(response)
    }
  } catch (e) {
    yield put(createReferralAction.failure(e))
  }
}

function* handleGetReferralDetails(action) {
  try {
    const { referralId, agentId } = action.data
    const res = yield call(getReferralDetailsAPI, referralId, agentId)
    if (isSuccess(res)) {
      const { response } = res.data
      yield put(getReferralDetailsAction.success(response))
    }
  } catch (e) {
    yield put(getReferralDetailsAction.failure(e))
  }
}

function* handleSaveReferralCover(action) {
  try {
    const {
      referralId,
      createPayload,
      coverPayload,
      isNew,
      callback,
    } = action.data || {}

    let id = referralId

    if (isNew || !id) {
      const createRes = yield call(createReferralAPI, createPayload || {})
      if (!isSuccess(createRes)) {
        yield put(saveReferralCoverAction.failure(createRes))
        return
      }
      const { response } = createRes.data
      id = response && response.referral_id
      yield put(createReferralAction.success(response))
    }

    if (!id) {
      yield put(saveReferralCoverAction.failure({ message: "Missing referral id" }))
      return
    }

    const res = yield call(updateReferralCoverAPI, id, coverPayload)
    if (isSuccess(res)) {
      const { response } = res.data
      yield put(saveReferralCoverAction.success(response))
      message.success("Referral saved successfully")
      yield put(toggleReferralDrawerAction.call({ bool: false, data: null }))
      yield put(getAllReferralsAction.request({
        skip: 0,
        limit: 25,
        sort_by: "created_at",
        sort_order: "desc",
      }))
      if (callback) callback(response, id)
    } else {
      yield put(saveReferralCoverAction.failure(res))
    }
  } catch (e) {
    yield put(saveReferralCoverAction.failure(e))
  }
}

function* handleUpdateReferralStatus(action) {
  try {
    const {
      referralId,
      status,
      notes,
      admin_name: adminNameFromAction,
      generate_contract: generateContract,
      refreshPayload,
    } = action.data || {}
    const user = cookie.load("user")
    const admin_name = adminNameFromAction || (user && user.twilio_client_name) || "anonymous"
    const res = yield call(updateReferralStatusAPI, {
      referral_id: referralId,
      status,
      notes: notes == null ? "" : notes,
      generate_contract: generateContract !== false,
      admin_name,
    })
    if (isSuccess(res)) {
      const { response } = res.data || {}
      yield put(updateReferralStatusAction.success(response))
      message.success("Referral status updated")
      yield put(getAllReferralsAction.request(
        refreshPayload || {
          skip: 0,
          limit: 25,
          sort_by: "created_at",
          sort_order: "desc",
        },
      ))
    } else {
      yield put(updateReferralStatusAction.failure(res))
      message.error((res.data && res.data.message) || "Could not update referral status")
    }
  } catch (e) {
    yield put(updateReferralStatusAction.failure(e))
    const fromBody = e.response && e.response.data
    const raw = (fromBody && (fromBody.message || fromBody.error)) || e.message
    const msg = typeof raw === "string" ? raw : "Could not update referral status"
    message.error(msg)
  }
}

export default function* main() {
  yield takeLatest(getAllReferralsAction.REQUEST, handleFetchReferrals)
  yield takeLatest(createReferralAction.REQUEST, handleCreateReferral)
  yield takeLatest(getReferralDetailsAction.REQUEST, handleGetReferralDetails)
  yield takeLatest(saveReferralCoverAction.REQUEST, handleSaveReferralCover)
  yield takeLatest(updateReferralStatusAction.REQUEST, handleUpdateReferralStatus)
}
